import { useMutation } from '@tanstack/react-query';

import { TCreateProjectDto, useAvApi } from '@app-velocity/av-api-v2';

export const CREATE_GUEST_PROJECT_MUTATION_KEY = 'create-guest-project-mutation';

export const useCreateGuestProjectMutation = () => {
  const { guestProjects } = useAvApi();

  return useMutation({
    mutationKey: [CREATE_GUEST_PROJECT_MUTATION_KEY],
    mutationFn: async (body: TCreateProjectDto) => {
      const response = await guestProjects.postV2GuestProjects(body);

      return response.data;
    },
  });
};
